export default function SubmissionTickIco() {
  return (
   <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="30" cy="29" r="17" fill="white"/>
<circle cx="28" cy="28" r="25.6667" stroke="#D5DADD" stroke-width="4.66667"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 28C0 12.536 12.536 0 28 0C43.4638 0 56 12.536 56 28C56 43.4638 43.4638 56 28 56C12.536 56 0 43.4638 0 28ZM38.3799 20.4201C39.4733 21.5136 39.4733 23.2865 38.3799 24.3799L28.068 34.6917C26.4841 36.2757 23.9159 36.2757 22.3319 34.6917L17.6201 29.9799C16.5266 28.8865 16.5266 27.1135 17.6201 26.0201C18.7136 24.9267 20.4864 24.9267 21.5799 26.0201L25.2 29.6402L34.4201 20.4201C35.5135 19.3266 37.2865 19.3266 38.3799 20.4201Z" fill="#17B26A"/>
</svg>

  );
}
